export enum MiscDefinitionValues {
  "Banner", "Major"
}
